import script from "./InicioCase.vue?vue&type=script&setup=true&lang=js"
export * from "./InicioCase.vue?vue&type=script&setup=true&lang=js"

import "./InicioCase.vue?vue&type=style&index=0&id=7420afd9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7420afd9"]])

export default __exports__